import { render, staticRenderFns } from "./TreeData.vue?vue&type=template&id=5c6e6c2b&scoped=true&"
import script from "./TreeData.vue?vue&type=script&lang=js&"
export * from "./TreeData.vue?vue&type=script&lang=js&"
import style0 from "./TreeData.vue?vue&type=style&index=0&id=5c6e6c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e6c2b",
  null
  
)

export default component.exports